import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "ihub_admin_token";
const USER_KEY = "ihub_admin_user";

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function getAdminUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

const client = axios.create({
  baseURL: API,
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});

client.interceptors.request.use((cfg) => {
  const token = getToken();
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    // Auto-logout on 401 from admin routes
    if (err?.response?.status === 401) {
      const url = err?.config?.url || "";
      if (url.includes("/admin/") || url.includes("/match-requests") || url.includes("/customers")) {
        clearSession();
      }
    }
    return Promise.reject(err);
  }
);

// ---------------- Public ----------------

export async function getOffers() {
  const { data } = await client.get("/offers");
  return data;
}

export async function getOffer(slug) {
  const { data } = await client.get(`/offers/${slug}`);
  return data;
}

export async function submitMatchRequest(payload) {
  const { data } = await client.post("/match-requests", payload);
  return data;
}

// ---------------- Admin auth ----------------

export async function adminLogin(email, password) {
  const { data } = await client.post("/admin/login", { email, password });
  setSession(data.token, data.user);
  return data;
}

export async function adminMe() {
  const { data } = await client.get("/admin/me");
  return data;
}

export function adminLogout() {
  clearSession();
}

// ---------------- Admin: leads + customers ----------------

export async function listMatchRequests(params = {}) {
  const { data } = await client.get("/match-requests", { params });
  return data;
}

export async function updateMatchRequest(id, body) {
  const { data } = await client.patch(`/match-requests/${id}`, body);
  return data;
}

export async function listCustomers() {
  const { data } = await client.get("/customers");
  return data;
}
